import Vue from 'vue'
export const removeCookies = () => {
    removeCookiesColunas()
    removeCookiesChat()
}

export const removeCookiesColunas = () => {
    const cookies = Vue.$cookies.keys()
    if (cookies.length === 0) {
        return
    }
    cookies.forEach(cookie => {
        if (cookie.startsWith('colunas')){
            Vue.$cookies.remove(cookie)
        }
    })
}

export const removeCookiesChat = () => {
    localStorage.removeItem('token_zendesk')
}

export const adicionaCookieModulo = (modulo) => {
    sessionStorage.setItem('modulo', modulo)
}

export const pegaCookieModulo = () => {
    return sessionStorage.getItem('modulo')
}

export const removeCookieModulo = () => {
    sessionStorage.removeItem('modulo')
}